import Colditz1 from '../../../Media/Citraland Kedamaian/Colditz/Colditz (1).webp'
import Colditz2 from '../../../Media/Citraland Kedamaian/Colditz/Colditz (2).webp'
import Colditz3 from '../../../Media/Citraland Kedamaian/Colditz/Colditz (3).webp'
import Colditz4 from '../../../Media/Citraland Kedamaian/Colditz/Colditz (4).webp'

const Colditzimages =[
Colditz1,Colditz2,Colditz3,Colditz4
]

export default Colditzimages;